import { render } from "./Wysiwyg.vue?vue&type=template&id=636f6ab2&scoped=true"
import script from "./Wysiwyg.vue?vue&type=script&lang=js"
export * from "./Wysiwyg.vue?vue&type=script&lang=js"

import "./Wysiwyg.vue?vue&type=style&index=0&id=636f6ab2&lang=scss&scoped=true"
import "./Wysiwyg.vue?vue&type=style&index=1&id=636f6ab2&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-636f6ab2"]])

export default __exports__